export default "__VITE_ASSET__BwparMSC__"